/**
 *
 * ButtonsMessage
 *
 */

import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { slideUp } from 'styles/animation';
import HyperlinkIconUrl from "assets/icons/hyperlinkIcon.svg";

const ButtonsWrapper = styled.div`
  flex-wrap: wrap;
  overflow: auto;
  font-size: 14px;
  opacity: 0;
  transform: translateY(10px);
  animation: ${slideUp} 0.4s ease-in-out 0.08s forwards;
  will-change: transform;
  text-align: right;
  ${p => p.grid ? 'display: flex' : ''};
  ${p => p.grid ? 'justify-content: flex-end' : ''};
`;

const HyperLinkDivider = styled.div`
  height: 24px;
  width: 0;
  border-right: 1px solid #5A6778;
  margin: 0 11px 0 14px;
`;

const Button = styled.div`
  align-items: center;
  box-sizing: unset;
  border-radius: 6px;
  padding: ${p => p.isHyperlinked ? 6 : 10}px 20px;
  max-width: ${p => p.grid ? '' : '215px' };
  text-align: left;
  cursor: pointer;
  margin-bottom: 5px;
  margin-top: 5px;
  background-color: ${p => p.grid ? p.headerBackgroundColor+"19" : p.theme.palette.blue5};
  border: 1px solid ${p => p.headerBackgroundColor};
  box-sizing: border-box;
  border-radius: 15px;
  color: ${p => p.theme.palette.text.one};
  display: inline-flex;
  margin-right: 10px;
  transition: background 0.2s;
  &:hover {
    color: ${p => p.headerTextColor};
    background-color: ${p => p.headerBackgroundColor};
  }
  &:hover img{
    filter: brightness(0) invert(1);
  }
  &:hover ${HyperLinkDivider}{
    border-right: 1px solid #FFFFFF;
  }
`;

const HyperLinkIconHolder = styled.div`
`;

const HyperLinkIcon = styled.img`
`;


export const ButtonsMessage = ({ message, processUserResponse, userSettingColor, grid, handleHyperLinkRedirects }) => {
  const buttons = message ? message.buttons : null;
  return (
    <ButtonsWrapper id="insent-buttons-message-buttons-wrapper" grid={grid}>
      {buttons && buttons.map((button, index) => (
        <Button
          id="insent-buttons-message-button"
          key={index}
          grid={grid}
          onClick={() => {
            if(handleHyperLinkRedirects && typeof handleHyperLinkRedirects === "function")handleHyperLinkRedirects(button);
            processUserResponse(typeof button ==="string"?[button]:[button.text], message.type, { ...message }, button.uid);
          }}
          headerBackgroundColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}
          headerTextColor={userSettingColor ? userSettingColor.headerTextColor : null}
          isHyperlinked={typeof button == "object" && !!button.hyperlink}
        >
          {typeof button == "string" && button}
          {typeof button == "object" && button.text}
          {typeof button == "object" && button.hyperlink &&
            <>
              <HyperLinkDivider />
              <HyperLinkIconHolder>
                <HyperLinkIcon src={HyperlinkIconUrl}/>
              </HyperLinkIconHolder>
            </>
          }
        </Button>
      ))}
    </ButtonsWrapper>
  );
};

ButtonsMessage.propTypes = {
  message: PropTypes.object,
  processUserResponse: PropTypes.func,
};

export default ButtonsMessage;
